import Vue from 'vue'
import VueRouter from 'vue-router'
Vue.use(VueRouter)

// 定义路由
// 每个路由应该映射一个组件。 其中"component"是一个组件配置对象。
const routes = [
  // 设置聊天列表页面为首页
  { 
    path: '/', 
    redirect: {
      name: 'discover'
    }
  },
  {
    path: '/discover',
    name: 'discover',
    component (resolve) {
      require(['../tlpage/Discovery'], resolve)
    }
  },
  {
    path: '/my',
    name: 'my',
    component (resolve) {
      require(['../tlpage/My'], resolve)
    }
  },
  {
    path: '/download',
    name: 'download',
    component (resolve) {
      require(['../tlpage/Download'], resolve)
    }
  },
  {
    path: '/myorder',
    name: 'myorder',
    component (resolve) {
      require(['../tlpage/MyOrder'], resolve)
    }
  },
  {
    path: '/about',
    name: 'about',
    component (resolve) {
      require(['../tlpage/About'], resolve)
    }
  },
  {
    path: '/phoneLogin',
    name: 'phoneLogin',
    component (resolve) {
      require(['../tlpage/PhoneLogin'], resolve)
    }
  },
  {
    path: '/mycomment',
    name: 'mycomment',
    component (resolve) {
      require(['../tlpage/MyComment'], resolve)
    }
  },
  {
    path: '/paydetail/:orderId/:tid',
    name: 'paydetail',
    component (resolve) {
      require(['../tlpage/PayDetail'], resolve)
    }
  },

  {
    path: '/mycoupon/:orderId',
    name: 'mycoupon',
    component (resolve) {
      require(['../tlpage/MyCoupon'], resolve)
    }
  },
  {
    path: '/releasecomment/:orderId/:tid',
    name: 'releasecomment',
    component (resolve) {
      require(['../tlpage/ReleaseComment'], resolve)
    }
  },
  {
    path: '/modifycomment/:content/:cmt_id',
    name: 'modifycomment',
    component (resolve) {
      require(['../tlpage/ModifyComment'], resolve)
    }
  },
  {
    path: '/taroterinfo/:tid',
    name: 'taroterinfo',
    component (resolve) {
      require(['../tlpage/TaroterInfo'], resolve)
    }
  },
  {
    path: '/searchresult/:keyword',
    name: 'searchresult',
    component (resolve) {
      require(['../tlpage/SearchResult'], resolve)
    }
  },
  {
    path: '/tarotersccommon/:tid/:index',
    name: 'tarotersccommon',
    component (resolve) {
      require(['../tlpage/TaroterSCCommon'], resolve)
    }
  },
  {
    path: '/taroterservice/:tid',
    name: 'taroterservice',
    component (resolve) {
      require(['../tlpage/TaroterService'], resolve)
    }
  },
  // 最近消息列表（会话）
  {
    path: '/session',
    name: 'session',
    component (resolve) {
      require(['../pages/Session'], resolve)
    }
  },
  // 系统消息
  {
    path: '/sysmsgs',
    name: 'sysmsgs',
    component (resolve) {
      require(['../pages/SysMsgs'], resolve)
    }
  },
  {
    path: '/chat/:sessionId/:name',
    name: 'chat',
    component (resolve) {
      require(['../pages/Chat'], resolve)
    }
  },
  // 聊天记录
  {
    path: '/chat/:sessionId',
    name: 'chat',
    component (resolve) {
      require(['../pages/Chat'], resolve)
    }
  },
  // 聊天历史记录
  {
    path: '/chathistory/:sessionId',
    name: 'chathistory',
    component (resolve) {
      require(['../pages/ChatHistory'], resolve)
    }
  },
  // 直播间
  {
    path: '/room',
    name: 'room',
    component (resolve) {
      require(['../pages/Room'], resolve)
    }
  },
  // 直播聊天页
  {
    path: '/roomChat/:chatroomId',
    name: 'roomChat',
    component (resolve) {
      require(['../pages/RoomChat'], resolve)
    }
  },
  // 通讯录
  {
    path: '/contacts',
    name: 'contacts',
    component (resolve) {
      require(['../pages/Contacts'], resolve)
    }
  },
  // 好友名片
  {
    path: '/namecard/:userId',
    name: 'namecard',
    component (resolve) {
      require(['../pages/NameCard'], resolve)
    }
  },
  // 好友名片-设置备注
  {
    path: '/namecardremark/:userId',
    name: 'namecardremark',
    component (resolve) {
      require(['../pages/NameCardRemark'], resolve)
    }
  },
  // 好友名片-搜索好友/群
  {
    path: '/searchuser/:searchType',
    name: 'searchuser',
    component (resolve) {
      require(['../pages/SearchUser'], resolve)
    }
  },
  // 通用页面
  {
    path: '/general',
    name: 'general',
    component (resolve) {
      require(['../pages/General'], resolve)
    }
  }
]

let router = new VueRouter({
  history: true,
  routes
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js